<template>
  <div id="app">
      <ConfigProvider :locale="zh_CN">
        <Main></Main>
      </ConfigProvider>
  </div>
</template>

<script>
import 'ant-design-vue/dist/antd.css';
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import { ConfigProvider } from 'ant-design-vue'
import Main from './pages/Main'
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
import './style.less'
export default {
  name: 'App',
  components: {
      Main,
      ConfigProvider
  },
  data() {
      return {
          zh_CN
      }
  }
}
</script>

<style lang="less" scoped>
#app {
    height: 100%;
    overflow: scroll;
}
</style>

